// extracted by mini-css-extract-plugin
export default {"typeMenu":"MapMenu_typeMenu__GHdGH","menuName":"MapMenu_menuName__JptuD"};